(ns lemonpi.ads-schema.facebook)

;; extracted from meta business sdk version 22

(def cta-options
  [{:key "ADD_TO_CART", :label "Add To Cart"}
   {:key "APPLY_NOW", :label "Apply Now"}
   {:key "ASK_ABOUT_SERVICES", :label "Ask About Services"}
   {:key "ASK_FOR_MORE_INFO", :label "Ask For More Info"}
   {:key "AUDIO_CALL", :label "Audio Call"}
   {:key "BOOK_A_CONSULTATION", :label "Book A Consultation"}
   {:key "BOOK_NOW", :label "Book Now"}
   {:key "BOOK_TRAVEL", :label "Book Travel"}
   {:key "BUY", :label "Buy"}
   {:key "BUY_NOW", :label "Buy Now"}
   {:key "BUY_TICKETS", :label "Buy Tickets"}
   {:key "BUY_VIA_MESSAGE", :label "Buy Via Message"}
   {:key "CALL", :label "Call"}
   {:key "CALL_ME", :label "Call Me"}
   {:key "CALL_NOW", :label "Call Now"}
   {:key "CHAT_WITH_US", :label "Chat With Us"}
   {:key "CONFIRM", :label "Confirm"}
   {:key "CONTACT", :label "Contact"}
   {:key "CONTACT_US", :label "Contact Us"}
   {:key "DONATE", :label "Donate"}
   {:key "DONATE_NOW", :label "Donate Now"}
   {:key "DOWNLOAD", :label "Download"}
   {:key "EVENT_RSVP", :label "Event Rsvp"}
   {:key "FIND_A_GROUP", :label "Find A Group"}
   {:key "FIND_YOUR_GROUPS", :label "Find Your Groups"}
   {:key "FOLLOW_NEWS_STORYLINE", :label "Follow News Storyline"}
   {:key "FOLLOW_PAGE", :label "Follow Page"}
   {:key "FOLLOW_USER", :label "Follow User"}
   {:key "GET_A_QUOTE", :label "Get A Quote"}
   {:key "GET_DIRECTIONS", :label "Get Directions"}
   {:key "GET_IN_TOUCH", :label "Get In Touch"}
   {:key "GET_OFFER", :label "Get Offer"}
   {:key "GET_OFFER_VIEW", :label "Get Offer View"}
   {:key "GET_PROMOTIONS", :label "Get Promotions"}
   {:key "GET_QUOTE", :label "Get Quote"}
   {:key "GET_SHOWTIMES", :label "Get Showtimes"}
   {:key "GET_STARTED", :label "Get Started"}
   {:key "INQUIRE_NOW", :label "Inquire Now"}
   {:key "INSTALL_APP", :label "Install App"}
   {:key "INSTALL_MOBILE_APP", :label "Install Mobile App"}
   {:key "JOIN_CHANNEL", :label "Join Channel"}
   {:key "LEARN_MORE", :label "Learn More"}
   {:key "LIKE_PAGE", :label "Like Page"}
   {:key "LISTEN_MUSIC", :label "Listen Music"}
   {:key "LISTEN_NOW", :label "Listen Now"}
   {:key "MAKE_AN_APPOINTMENT", :label "Make An Appointment"}
   {:key "MESSAGE_PAGE", :label "Message Page"}
   {:key "MOBILE_DOWNLOAD", :label "Mobile Download"}
   {:key "NO_BUTTON", :label "No Button"}
   {:key "OPEN_INSTANT_APP", :label "Open Instant App"}
   {:key "OPEN_LINK", :label "Open Link"}
   {:key "ORDER_NOW", :label "Order Now"}
   {:key "PAY_TO_ACCESS", :label "Pay To Access"}
   {:key "PLAY_GAME", :label "Play Game"}
   {:key "PLAY_GAME_ON_FACEBOOK", :label "Play Game On Facebook"}
   {:key "PURCHASE_GIFT_CARDS", :label "Purchase Gift Cards"}
   {:key "RAISE_MONEY", :label "Raise Money"}
   {:key "RECORD_NOW", :label "Record Now"}
   {:key "REFER_FRIENDS", :label "Refer Friends"}
   {:key "REQUEST_TIME", :label "Request Time"}
   {:key "SAY_THANKS", :label "Say Thanks"}
   {:key "SEE_MORE", :label "See More"}
   {:key "SELL_NOW", :label "Sell Now"}
   {:key "SEND_A_GIFT", :label "Send A Gift"}
   {:key "SEND_GIFT_MONEY", :label "Send Gift Money"}
   {:key "SEND_UPDATES", :label "Send Updates"}
   {:key "SHARE", :label "Share"}
   {:key "SHOP_NOW", :label "Shop Now"}
   {:key "SIGN_UP", :label "Sign Up"}
   {:key "SOTTO_SUBSCRIBE", :label "Sotto Subscribe"}
   {:key "START_ORDER", :label "Start Order"}
   {:key "SUBSCRIBE", :label "Subscribe"}
   {:key "SWIPE_UP_PRODUCT", :label "Swipe Up Product"}
   {:key "SWIPE_UP_SHOP", :label "Swipe Up Shop"}
   {:key "UPDATE_APP", :label "Update App"}
   {:key "USE_APP", :label "Use App"}
   {:key "USE_MOBILE_APP", :label "Use Mobile App"}
   {:key "VIDEO_ANNOTATION", :label "Video Annotation"}
   {:key "VIDEO_CALL", :label "Video Call"}
   {:key "VIEW_CART", :label "View Cart"}
   {:key "VIEW_CHANNEL", :label "View Channel"}
   {:key "VIEW_PRODUCT", :label "View Product"}
   {:key "VISIT_PAGES_FEED", :label "Visit Pages Feed"}
   {:key "WATCH_LIVE_VIDEO", :label "Watch Live Video"}
   {:key "WATCH_MORE", :label "Watch More"}
   {:key "WATCH_VIDEO", :label "Watch Video"}
   {:key "WHATSAPP_MESSAGE", :label "Whatsapp Message"}
   {:key "WOODHENGE_SUPPORT", :label "Woodhenge Support"}])

(def cta-keys (mapv :key cta-options))
